import * as React from "react";
import { FieldProps, Text, useFieldState, useFieldApi } from "informed";
import { inputClasses } from "../validation/ValidationClasses";

interface TextBoxWithStaticSuffixProps<V, VS> extends FieldProps<V, VS> {
    staticpart: string;
}

export const TextBoxWithStaticSuffix = <V, VS>({ field, ...props }: TextBoxWithStaticSuffixProps<V, VS>) => {
    const fieldState = useFieldState(field);
    const fieldApi = useFieldApi(field);

    return (
        <>
            <div className="input-group">
                <Text<V, VS>
                    field={field}
                    className={inputClasses(fieldApi.getError())}
                    {...props}
                />
                <span className="input-group-addon">{props.staticpart}</span>
            </div>
            {fieldApi.getError() ? <span className="field-validation-error">{fieldApi.getError()}</span> : null}
        </>
    );
}
